<template>
  <v-select
    v-model="select"
    :items="items"
    @change="setSelect"
    prepend-icon="mdi-list-status"
    item-text="text"
    item-value="categoy"
    :label="$t('category')"
    dense
    filled
    hide-details
    solo-inverted
  ></v-select>
</template>
<script>
export default {
  name: "components-common-filters-select-financial-category-agent",
  data: () => ({}),
  computed: {
    select() {
      return { text: this.$t("paidAndReceiverFromAgent"), categoy: 3 };
    },
    items() {
      return [
        { text: this.$t("paidAndReceiverFromAgent"), categoy: 3 },
        { text: this.$t("onlyReceivedFromAgent"), categoy: 1 },
        { text: this.$t("onlyPaitToTheAgent"), categoy: 2 },
      ];
    },
  },
  methods: {
    setSelect(category) {
      this.$store.commit("setSelectFinancialCategoryAgent", category);
    },
  },
};
</script>
